import { GridRow } from '@tkww/orion-web-ds-structure';
import classNames from 'classnames';
import React, { type FC } from 'react';
import { connect } from 'react-redux';
import ClientStyles from '../../../styles.scss';
import {
	ensureWeddingPrefix,
	generateCategoryDisplayName,
} from '../../../utils/categoryContentHelper';
import CityRecommendations from './CityRecommendations';
import Styles from './styles.scss';

export interface AdditionalCitiesRecommendationsProps {
	cities: string[];
	category: Redux.State['category'];
	stateName: string;
}

const AdditionalCitiesRecommendations: FC<
	AdditionalCitiesRecommendationsProps
> = ({ cities, category, stateName }) => {
	return (
		<div
			className={classNames(Styles.outerContainer, Styles.outerContainerWide)}
		>
			<div
				className={classNames(
					Styles.additionalCitiesContainer,
					Styles.additionalCitiesContainerWide,
				)}
			>
				<h4 className={classNames(Styles.header, Styles.headerWide)}>
					{`More ${ensureWeddingPrefix(generateCategoryDisplayName(category))} `}
					<span
						className={ClientStyles.whiteSpaceNowrap}
					>{`in ${stateName}`}</span>
				</h4>

				<GridRow>
					{cities.map((city) => (
						<CityRecommendations city={city} key={city} />
					))}
				</GridRow>
			</div>
		</div>
	);
};

const mapStateToProps = (state: Redux.State) => ({
	category: state.category,
	cities: state.states.cities,
	stateName: state.states.name,
});

export default connect(mapStateToProps)(AdditionalCitiesRecommendations);
